import { StatCard, useTranslation } from '@hbs-us/ui';

import type { MoneyFormatters } from '../../_money/useMoneyFormatters.js';

/**
 * The 4-card summary stat grid on the estimates list (UI-SPEC Estimates feature
 * folder): **Total Estimates** · **Pipeline Value** (`--chart-4` amber) ·
 * **Draft + Ready** · **Approved** (`--chart-3` green). Values are the
 * server-computed rollups from the coarse endpoint (21-05 — no client
 * re-aggregation). CSS grid + region semantics (NOT a layout table — A11Y-01);
 * the money values render in IBM Plex Mono; counts in mono too for alignment.
 */

function SummaryStatCard({ label, value }: { label: string; value: string }) {
  return <StatCard label={label} value={value} />;
}

export function EstimateSummaryCards({
  totalEstimates,
  pipelineValue,
  draftReadyCount,
  approvedCount,
  fmt,
}: {
  totalEstimates: number;
  pipelineValue: number;
  draftReadyCount: number;
  approvedCount: number;
  fmt: MoneyFormatters;
}) {
  const { t } = useTranslation();

  return (
    <section
      aria-label={t('estimates:summary.regionLabel')}
      className="mb-4 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4"
    >
      <SummaryStatCard
        label={t('estimates:summary.totalEstimates')}
        value={String(totalEstimates)}
      />
      <SummaryStatCard
        label={t('estimates:summary.pipelineValue')}
        value={fmt.formatCurrency(pipelineValue)}
      />
      <SummaryStatCard label={t('estimates:summary.draftReady')} value={String(draftReadyCount)} />
      <SummaryStatCard label={t('estimates:summary.approved')} value={String(approvedCount)} />
    </section>
  );
}
